/*
 * @Author: cryi.liu
 * @Date: 2020-06-04 10:26:34
 * @LastEditTime: 2020-06-04 10:58:33
 * @Description: js-base64 插件包
 */
import { Base64 } from 'js-base64';

const Plugin = {
  install(Vue, name = '$base64') {
    Object.defineProperty(Vue.prototype, name, { value: Base64 });
  },
};

export default Plugin;
